export default "__VITE_ASSET__02ff3929__"